import React from 'react';
import MapView from './components/Mapview';

function App() {
  return <MapView />;
}

export default App;
